import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Stack,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SignupCompletePopup = ({
  open,
  onClose,
  onCloseIcon,
  acctID,
  isAventiAccountCreated
}) => {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(5);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    let timer;

    if (open && isAventiAccountCreated) {
      setCountdown(5);
      setIsButtonDisabled(false);

      timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setIsButtonDisabled(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [open, isAventiAccountCreated]);

  const handleClosePopup = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} className="login-popup">
      <Stack
        sx={(theme) => ({
          background: theme.palette.common.black,
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
        })}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {acctID > 0
            ? t("SignupCommonField.AffiliateSignUp.PurchaseTitle")
            : t("SignupCommonField.AffiliateSignUp.ThankYouTitle")}
          <IconButton
            aria-label="close"
            className="cm-more-title-icon"
            onClick={onCloseIcon}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
              p: 1,
              borderRadius: "8px",
            })}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      </Stack>
      <DialogContent
        sx={(theme) => ({
          background: "var(--background-card)!important",
          border: 0,
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          alignItems: "center",
        })}
        dividers
      >
        {acctID > 0 ? (
          t("SignupCommonField.AffiliateSignUp.UpgradeMsg")
        ) : (
          <>
            <Typography variant="h6">
              {t("SignupCommonField.AffiliateSignUp.ThankYouText1")}
            </Typography>

            <Typography sx={{}} variant="body2" color="text.secondary">
              {t("SignupCommonField.AffiliateSignUp.ThankYouText2")}
            </Typography>
          </>
        )}
        <Stack
          direction={"row"}
          gap={1.5}
          justifyContent="center"
          sx={{ flexWrap: {xs: "wrap", sm: "nowrap"}, width: "100%" }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{width: "100%" }}
            onClick={() => onClose(isButtonDisabled ? "dashboardAventi" : "dashboard")}
          >
            {isButtonDisabled
              ? t("SignupCommonField.AffiliateSignUp.GoToAventi")
              : t("SignupCommonField.IBOSignup.BYLDDashboardButtonText")}
          </Button>
          {isAventiAccountCreated && (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => onClose("bookNow")}
              sx={{ width: "100%" }}
              disabled={isButtonDisabled}
            >
              {t("SignupCommonField.AffiliateSignUp.BookNow")}{" "}
              {countdown > 0 && `(${countdown})`}
            </Button>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default SignupCompletePopup;